import { apiCall } from './gqlClient';
const GETZOOMUSER_QUERY = "\n  query getZoomUser {\n    getZoomUser\n  }";
export const getZoomUserApiCall = async () => apiCall({
  query: GETZOOMUSER_QUERY,
  variables: {}
});
const GENERATEZOOMMEETING_QUERY = "\n  query generateZoomMeeting {\n    generateZoomMeeting\n  }";
export const generateZoomMeetingApiCall = async () => apiCall({
  query: GENERATEZOOMMEETING_QUERY,
  variables: {}
});
const GETLATESTZOOMMEETINGURL_QUERY = "\n  query getLatestZoomMeetingUrl {\n    getLatestZoomMeetingUrl\n  }";
export const getLatestZoomMeetingUrlApiCall = async () => apiCall({
  query: GETLATESTZOOMMEETINGURL_QUERY,
  variables: {}
});
const ZOOMCHECKIFPROVIDERCONNECTED_QUERY = "\n  query zoomCheckIfProviderConnected {\n    zoomCheckIfProviderConnected\n  }";
export const zoomCheckIfProviderConnectedApiCall = async () => apiCall({
  query: ZOOMCHECKIFPROVIDERCONNECTED_QUERY,
  variables: {}
});
const DISCONNECTZOOM_QUERY = "\n  mutation disconnectZoom {\n    disconnectZoom\n  }";
export const disconnectZoomApiCall = async () => apiCall({
  query: DISCONNECTZOOM_QUERY,
  variables: {}
});